/**
 * @author Ariel
 * @description 调查问卷模版页面配置
 * @Date 2020/3/18
 */
import React from 'react'

import { component_tool } from '../../../tool';
let { WizModal } = component_tool;

//配置项
let componentName = 'surveyTemplate'

const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "模版名称",
    name: "title",
    searchItem: {},
    tableItem: {
      width: 400
    }
  },
  {
    title: "问卷类型",
    name: "type",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '普通问卷' },
      { code: 1, codeName: '随堂问卷' },
      { code: 2, codeName: '回执问卷' },
      { code: 3, codeName: '满意度问卷' }
    ],
    tableItem:{}
  },
  {
    title: "状态",
    name: "status",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 1, codeName: '打开' },
      { code: 0, codeName: '关闭' }
    ],
    tableItem: {}
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort:['add','delete'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/biz/surveyTemplate/surveyTemplateDetailAdd'
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort:['update','openOrClose','preview','quoteTemplate'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/biz/surveyTemplate/surveyTemplateDetailUpd"
            }
          }
        },
        {
          key: "openOrClose",
          custom: true,
          params: { children: "打开" },
          textFormat: {
            recordKey: 'status',
            dirt: { '1': '关闭', '0': '打开', }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['status'] === 0 ? "打开" : "关闭"
              }该模版吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    ...filters
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "preview",
          custom: true,
          params: { children: "预览"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/biz/surveyTemplate/surveyTemplatePreview"
            }
          }
        },
        {
          key: "quoteTemplate",
          custom: true,
          params: { children: "引用该模版"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/biz/survey/surveyDetailAdd",
              record: {"channelType":"temp"}
            }
          },
          recordChangeParams: ({ record, rows }) => {
            let disabled = true
            if (record && record['status'] === 1) {
              disabled = false
            }
            return { disabled }
          }
        }
      ]
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
